import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center mt-5"
}
const _hoisted_3 = ["onClick", "disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_14 = { key: 1 }

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleForm',
  props: {
    title: {},
    isLoading: { type: Boolean },
    discard: {},
    submit: {},
    submitted: { type: Boolean },
    saveTitle: {},
    savingTitle: {},
    discardTitle: {},
    elId: {},
    width: { default: 650 },
    submitColor: { default: "primary" },
    discardColor: { default: "light" },
    disableSubmit: { type: Boolean, default: false },
    disableDiscard: { type: Boolean, default: false },
    disableHeader: { type: Boolean, default: false },
    disableFooter: { type: Boolean, default: false },
    appendBody: { type: Boolean, default: false },
    minHeight: { default: 0 },
    minWidth: {},
    beforeClose: {},
    delayReview: { type: Boolean },
    delayReviewHandler: {},
    overflow: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const formVisible = ref(false);
const isSubmitting = ref(false);
const isDiscarding = ref(false);
const submitHandler = async (event) => {
  event.preventDefault();
  isSubmitting.value = true;
  if (props.submit) {
    await props.submit();
  } else {
    formVisible.value = false;
  }
  isSubmitting.value = false;
};

const delayReviewHandler = async (event) => {
  event.preventDefault();
  isSubmitting.value = true;
  if (props.delayReviewHandler) {
    await props.delayReviewHandler();
  } else {
    formVisible.value = false;
  }
  isSubmitting.value = false;
};

const discardHandler = async () => {
  isDiscarding.value = true;
  if (props.discard) {
    await props.discard();
  } else {
    formVisible.value = false;
  }
  isDiscarding.value = false;
};

const handleBeforeClose = async (done: () => void) => {
  try {
    if (props.beforeClose) {
      const result = props.beforeClose();
      if (result && typeof (result as any).then === "function") {
        await result;
      }
    }
  } finally {
    done();
  }
};

__expose({
  hide: () => (formVisible.value = false),
  show: () => {
    isSubmitting.value = false;
    formVisible.value = true;
  },
});

const randomId = ref("");
onMounted(() => {
  randomId.value = Math.random().toString(36).substring(2, 8);
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: formVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formVisible).value = $event)),
    title: _ctx.title,
    width: `${props.width}px`,
    "align-center": "",
    class: "card",
    "append-to-body": _ctx.appendBody,
    "before-close": handleBeforeClose,
    style: _normalizeStyle({
      'min-width': `${_ctx.minWidth}px !important`,
    }),
    overflow: props.overflow
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(props.overflow ? 'overflow-hidden' : 'overflow-auto'),
          style: _normalizeStyle([{"max-height":"800px"}, {
          'min-height': `${props.minHeight}px !important`,
        }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 6),
        (!_ctx.disableFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                class: _normalizeClass({
            [`btn btn-${props.discardColor} me-3`]: true,
          }),
                onClick: _withModifiers(discardHandler, ["prevent"]),
                disabled: props.disableDiscard || isSubmitting.value
              }, [
                (isDiscarding.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.waiting")) + " ", 1),
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.discardTitle ? props.discardTitle : _ctx.$t("action.discard")), 1))
              ], 10, _hoisted_3),
              _createElementVNode("button", {
                class: _normalizeClass({
            [`btn btn-${props.submitColor} me-3`]: true,
          }),
                onClick: submitHandler,
                disabled: props.isLoading || props.disableSubmit || isDiscarding.value
              }, [
                (isSubmitting.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.waiting")) + " ", 1),
                      _hoisted_9
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(props.saveTitle ? props.saveTitle : _ctx.$t("action.submit")), 1))
              ], 10, _hoisted_7),
              (_ctx.$props.delayReview)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass({
            [`btn btn-success me-3`]: true,
          }),
                    onClick: delayReviewHandler,
                    disabled: props.isLoading
                  }, [
                    (isSubmitting.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.waiting")) + " ", 1),
                          _hoisted_13
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("action.delayReview")), 1))
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "title", "width", "append-to-body", "style", "overflow"]))
}
}

})